import { isEmpty } from 'lodash-es';

export default class FormValidator {
	constructor(validators, values) {
		this.init(validators, values);
	}

	init(validators = {}, values = {}) {
		this.validators = validators;
		this.values = values;
		this.errors = {};
		for (const field in this._fieldNames) {
			this.errors[field] = null;
		}
	}

	validateField(fieldName) {
		if (this.validators[fieldName]) {
			const fn = this.validators[fieldName].fn;
			this.errors[fieldName] = null;
			if (!fn.call(this, this.values[fieldName])) {
				this.errors[fieldName] = this.validators[fieldName].error;
			}
		}

		return this;
	}

	validateAll() {
		for (const field of this._fieldNames) {
			this.validateField(field);
		}

		return this;
	}

	isValid(fieldName) {
		return !this.errors[fieldName];
	}

	get hasErrors() {
		for (const field of this._fieldNames) {
			if (!this.isValid(field)) {
				return true;
			}
		}

		return false;
	}

	setValue(field, value) {
		this.values[field] = value;
		return this;
	}

	setValues(values) {
		this.values = values;
		return this;
	}

	getError(field) {
		return this.errors[field] || null;
	}

	get _fieldNames() {
		return Object.keys(this.validators);
	}
}

export const validators = {
	required: (value) => !isEmpty(value),
};
